<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section">
          <div class="container">
            <h1 class="title">
              {{ $t('Estimado') }} {{ neofintechData.userData.firstName }}
              {{ neofintechData.userData.lastName }},
            </h1>
            <p>
              {{ $t('Finish') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  }
}
</script>
